module.exports = __webpack_public_path__ + "img/coloredeer2..ee0fbcdf.jpg";